import * as THREE from 'three';
import settings from '../../config/Settings';
import constants from '../../config/Constants';
import nearStarsData from '../../config/NearStarsData';
import labelFactory from '../../LabelFactory';

class NearStars  {
  constructor() {
    this.three = {
      nearStars: nearStarsData.map(nearStarInfo => this.createNearStar(nearStarInfo))
    }
  }

  createNearStar(starData) {
    const position = new THREE.Spherical(starData.dis, starData.dec, starData.asc)

    // Create star
    const star = new THREE.Sprite(new THREE.SpriteMaterial({
      map: new THREE.TextureLoader().load(settings.imgDir + 'starsprite.png'),
      blending: THREE.AdditiveBlending,
      color: 0xffffff,
    }))
    star.scale.x = 2000 * constants.UD
    star.scale.y = 2000 * constants.UD
    star.scale.z = 4
    star.position.setFromSpherical(position)

    // Create label
    const label = labelFactory.createLabel('star', starData.name)
    label.position.setFromSpherical(position)
    
    // Group star + label
    const group = new THREE.Group()
    group.type = 'nearStar'
    group.name = starData.name
    group.mainObject = star
    group.label = label
    group.add(star)
    group.add(label)

    return group
  }

  getLabels() {
    return this.three.nearStars.map(nearStar => nearStar.label)
  }
}

export default NearStars